import { ApiErrorI } from '@liquidweb-dev/club-sauce';
import toast from '@liquidweb-dev/undercurrent/toast';
import {
	LWApiPublicServerRebootParamsRawI,
	LWApiPublicServerRebootResultRawI,
} from '@liquidweb-dev/club-sauce/public/server/index.raw';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NOTIFICATIONS_CURRENT_QUERY_KEY } from 'modules/queries/notification/useCurrent';
import { USERTASK_LIST_QUERY_KEY } from 'modules/queries/usertask/useList';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import api from '../api';
import useInvalidateAssets from '../invalidateQueries/useInvalidateAssets';

export const SERVER_REBOOT_REQUEST = '/server/reboot';

const useRebootRequest = () => {
	const snackbarError = useSnackbarError();
	const invalidateAssets = useInvalidateAssets();
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicServerRebootResultRawI,
		ApiErrorI,
		LWApiPublicServerRebootParamsRawI
	>({
		mutationKey: [SERVER_REBOOT_REQUEST],
		mutationFn: (params) => api.server.apiRaw.reboot(params),
		onError: snackbarError,

		onSuccess: (_data, params) => {
			invalidateAssets(params.uniq_id);
			queryClient.invalidateQueries([USERTASK_LIST_QUERY_KEY]);

			queryClient.invalidateQueries({
				queryKey: [NOTIFICATIONS_CURRENT_QUERY_KEY],
			});

			toast.success('Server reboot has started');
		},
	});
};

export default useRebootRequest;
